import Link from "next/link"
import { useState } from "react"
import { BorderedButton } from "src/components/Button"
import type { User } from "src/hooks/useUserSWR"

type Props = {
  users: User[]
  onSearch: (searchParams: string) => void
  isLoading?: boolean
}

export const Users: React.FC<Props> = (props) => {
  const [searchParams, setSearchParams] = useState("")

  const search = () => {
    props.onSearch(searchParams)
  }

  return (
    <div className="py-8">
      <div className="mx-auto flex w-8/12 flex-col items-center justify-center">
        <div className="padding-[20px] mx-auto my-4 flex w-full items-center justify-center">
          <input
            name="searchParams"
            placeholder="User ID・名前・電話番号・LINEユーザー名で検索"
            value={searchParams}
            onChange={(e) => setSearchParams(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                search()
              }
            }}
            style={{
              border: "1px solid rgb(209 213 219)",
              width: "480px",
            }}
            className="mr-4 rounded-md border border-gray-300 px-4 py-2 text-[1.6rem]"
          />
          <BorderedButton
            onClick={() => {
              search()
            }}
          >
            検索
          </BorderedButton>
        </div>
        {props.users.map((user, index) => {
          const items = {
            id: user.id,
            name: `${user.lastName || ""}` + " " + `${user.firstName || ""}`,
            nameKana: `${user.lastFurigana || ""}` + " " + `${user.firstFurigana || ""}`,
            createdAt: user.createdAt,
            updatedAt: user.updatedAt,
          }
          return (
            <Link
              key={user.id}
              href={`/admin/users/${user.id}`}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: index % 2 === 0 ? "#eee" : "#fff",
              }}
            >
              {Object.entries(items).map(([key, value]) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    marginRight: 10,
                    padding: 10,
                    overflow: "scroll",
                    width: 1200 / Object.keys(items).length,
                  }}
                >
                  <span>{key}</span>

                  <strong
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {key === "iconSrc" ? (
                      // eslint-disable-next-line @next/next/no-img-element
                      <img src={value as string} style={{ width: 50, height: 50 }} alt="icon" />
                    ) : (
                      value || ""
                    )}
                  </strong>
                </div>
              ))}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
